// ==============================|| PARTY GROUP TYPES ||============================== //

import { BusinessAreaDto, ContactListItem, PartyRevenueStatistics, PartyType } from './contacts';
import { OfficeMin } from './offices';
import { NamedEntityMinDto } from './other';
import { TeamMinDto } from './teams';

export enum GroupPartnershipType {
    REGULAR = 'REGULAR',
}

export enum GroupMemberRoleType {
    PRIMARY_CONTACT = 'PRIMARY_CONTACT',
    MEMBER = 'MEMBER',
}

export enum GroupEmployeeRoleType {
    RELATIONSHIP_PARTNER = 'RELATIONSHIP_PARTNER',
    RELATIONSHIP_MANAGER = 'RELATIONSHIP_MANAGER',
}

export enum GroupType {
    CORPORATE = 'CORPORATE',
    ALLIANCE = 'ALLIANCE',
    OTHER = 'OTHER',
}

export interface PartyGroup extends PartyGroupListItem {
    businessAreas?: PartyGroupBusinessArea[];
    notes?: string;
    groupTypeCode: GroupType | null;
    operatesInBusinessArea?: BusinessAreaDto[];
    servedByOffices?: OfficeMin[];
    servedByPracticeGroups?: TeamMinDto[];
    relatedMatterCount?: number;
    revenueStatistics?: PartyRevenueStatistics;
}

export interface PartyGroupListItem {
    id: number;
    groupName: string;
    groupPartnershipTypeCode: string;
    segmentTypeCode: string | null;
    serviceLevelTypeCode: string | null;
    lastEffortDate?: string;
    lastHCSEffortDate?: string;
    employees?: PartyGroupEmployee[];
    parties?: PartyGroupParty[];
    isDraft?: boolean;
}

export interface PartyGroupForm {
    groupType: GroupType | null;
    groupName: string;
    groupPartnershipType: { label: string; value: string } | null;
    segmentType: { label: string; value: string } | null;
    serviceLevelType: { label: string; value: string } | null;
    businessAreas: { label: string; value: string }[];
    members: { id: number; name: string; partyType: PartyType }[];
    primaryContacts: NamedEntityMinDto[];
    relationshipManagers: NamedEntityMinDto[];
    relationshipPartners: NamedEntityMinDto[];
    notes: string;
}

export interface PartyGroupMin {
    id: number;
    groupName: string;
    groupPartnershipTypeCode: string | null;
    groupTypeCode: string | null;
}

export interface PartyGroupDto {
    groupTypeCode: string | null;
    groupName: string;
    groupPartnershipTypeCode: string | null;
    segmentTypeCode: string | null;
    serviceLevelTypeCode: string | null;
    businessAreas: string[];
    members: { id: number }[];
    primaryContacts: { id: number }[];
    relationshipManagers: { id: number }[];
    relationshipPartners: { id: number }[];
    notes: string;
}

export interface PartyGroupUpdateDto extends PartyGroupDto {
    id: string | number;
}

export interface PartyGroupParty {
    party: ContactListItem;
    groupMemberRoleTypeCode: string;
}

export interface PartyGroupEmployee {
    employee: NamedEntityMinDto;
    groupEmployeeRoleTypeCode: string;
}

interface PartyGroupBusinessArea {
    businessAreaTypeCode: string;
}
